<!-- PAGE CONTENT WRAPPER -->
<div class="page-content-wrap contentdata">
  <div class="row">
    <div class="col-md-12">

      <div class="page-breadcrumb">
        <ul class="page-breadcrumb__trail">
          <li><a>Manage</a></li>
          <li><a>Devices</a></li>
          <li><a>Models</a></li>
        </ul>
      </div>

      <div class="block">
        <div class="page-header">
          <span class="page-header__title">Device Models</span>
          <img src="assets/images/New_Icons/refresh-icon.svg" alt="Refresh icon" title="Refresh" class="page-header__icon" width="17" height="17" (click)="!enableDisablePageLoader ? ngOnInit() : null"/>
        </div>
        <div class="list_block">
          <div class="toolbar">
            <div class="toolbar__search">
              <img src="../../../../../../assets/images/New_Icons/search-icon.svg" alt="Search icon">
              <input type="text" (ngModelChange)="onSearchChanged()" [(ngModel)]="search" name="search" autocomplete="off" placeholder="Search by device model name, code"/>
            </div>
            <div class="toolbar__spacer"></div>
            <div class="toolbar__add-button" (click)="openForm()">
              <button type="button">
                <span class="toolbar__add-icon">
                  <img src="../../../../../../assets/images/New_Icons/plus-icon.svg" alt="Add Icon"/>
                </span>
                <span class="toolbar__add-text">Add New</span>
              </button>
            </div>
          </div>
        </div>
        <div *ngIf="enableDisablePageLoader">
          <div class="adjust">
            <div class="loader2"></div>
          </div>
        </div>
        <div class="cards_container" *ngIf="!enableDisablePageLoader">
          <div class="card_wrapper" *ngFor="let devicemodel of deviceModelsList; let i = index">
            <div class="master-card">
              <div class="master-card-header">
                <div class="master-card-title">
                  <img src="../../../../../../assets/images/New_Icons/card-heading.svg" alt="Left arrow icon">
                  <span>{{ devicemodel && devicemodel.name }}</span>
                </div>
              </div>
              <div class="master-card-body">
                <div class="master-card-body-info">
                  <span class="card-content-text">Abbreviation:</span>
                  <span class="text">{{ devicemodel?.abbreviation || 'NA' }}</span>
                </div>
                <div class="master-card-body-info">
                  <span class="card-content-text">Description:</span>
                  <span class="text">{{ devicemodel?.description || 'NA' }}</span>
                </div>
                <div class="master-card-body-info">
                  <span class="card-content-text">Created At:</span>
                  <span class="text">{{ devicemodel?.createdAt | date: "dd MMM yyyy" }}</span>
                </div>
              </div>
              <div class="master-card-footer">
                <div class="master-card-footer-info">
                  <span class="label">Updated At:</span>
                  <span class="text">{{ devicemodel?.updatedAt | date: "dd MMM yyyy" }}</span>
                </div>
                <div class="action-icons">
                  <a>
                    <img src="../../../../../../assets/images/New_Icons/edit.svg" alt="Edit icon" title="Edit Device Model" (click)="getDeviceModelById(devicemodel.id)">
                  </a>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div *ngIf="listLoader" class="loader-div">
          <div class="adjust">
            <div class="loader2 list-loader"></div>
          </div>
        </div>
        <div *ngIf="noList && !enableDisablePageLoader" class="noDataFoundMessage">Device Models Not Found</div>
      </div>

      <!--add/update form-->
      <div class="dynamic-form-wrapper" [ngClass]="{ 'floating-panel': formFieldCount <= 7, 'slide-in-overlay': formFieldCount > 7}" *ngIf="showForm">
        <div class="popup-wrapper">
          <button type="button" class="popup-close-beside" (click)="closeForm()" title="Close">&times;</button>
          <!-- Actual Popup -->
          <div [ngClass]="{ 'form-container-panel': formFieldCount > 7, 'popup-inner': formFieldCount <= 7}">
            <form [formGroup]="registerForm" novalidate>
              <div class="form-header">
                <div class="form-title">Device Model</div>
                <button type="button" class="add-update-submit-button" (click)="addUpdateDeviceModel()" [disabled]="deviceModelDoubleClick">
                  <span class="icon"><img src="../../../../../../assets/images/New_Icons/tick-icon.svg" alt="Tick icon"></span>
                  <span class="text">{{ submitButton ? 'Submit' : 'Update' }}</span>
                </button>
              </div>
              <div class="form-container">
                <mat-form-field appearance="outline" class="w-100 density-compact">
                  <mat-label>Name</mat-label>
                  <input matInput type="text" formControlName="name" [(ngModel)]="deviceModel.name" autocomplete="off" placeholder="Enter model name"/>
                  <mat-hint><i>3–20 alphanumeric characters</i></mat-hint>
                  <mat-error *ngIf="(f.name.dirty || f.name.touched || submitted) && f.name.errors">
                    <i>{{ f.name.hasError('required') ? 'Name is required.' : f.name.hasError('minlength') ? 'Minimum 3 characters required.' : f.name.hasError('maxlength') ? 'Maximum 20 characters allowed.' : f.name.hasError('pattern') ? 'Special characters are not allowed.' : '' }}</i>
                  </mat-error>
                </mat-form-field>

                <mat-form-field appearance="outline" class="w-100 density-compact">
                  <mat-label>Abbreviation</mat-label>
                  <input matInput type="text" formControlName="abbreviation" [(ngModel)]="deviceModel.abbreviation" autocomplete="off" placeholder="Enter code"/>
                  <mat-hint><i>10 alphanumeric characters</i></mat-hint>
                  <mat-error *ngIf="(f.abbreviation.touched || f.abbreviation.dirty || submitted) && f.abbreviation.errors">
                    <i>{{ f.abbreviation.hasError('required') ? 'Abbreviation is required.' : f.abbreviation.hasError('maxlength') ? 'Maximum 10 characters allowed.' : f.abbreviation.hasError('pattern') ? 'Special characters are not allowed.' : '' }}</i>
                  </mat-error>
                </mat-form-field>

                <mat-form-field appearance="outline" class="w-100 density-compact">
                  <mat-label>Description</mat-label>
                  <textarea matInput rows="3" formControlName="description" [(ngModel)]="deviceModel.description" autocomplete="off" placeholder="Description"></textarea>
                  <mat-hint><i>Up to 200 characters</i></mat-hint>
                  <mat-error *ngIf="(f.description.dirty || f.description.touched || submitted) && f.description.hasError('maxlength')">
                    <i>Maximum 200 characters allowed.</i>
                  </mat-error>
                </mat-form-field>
              </div>
            </form>
          </div>
        </div>
      </div>

    </div>
  </div>
</div>
